<template>
    <el-dialog
            class="detail-dialog-container"
            :visible.sync="applyDialogVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="500px"
            center>
        <div class="dialog-container flex flex-direction padding">
            <div class="dialog-header flex">
                <div class="dialog-title flex-sub">添加客服信息</div>
                <i class="dialog-close el-icon-close" @click="cancel"></i>
            </div>
            <el-form class="form" :model="ruleForm" :rules="rules" ref="ruleForm" labelWidth="auto">
                <el-form-item prop="name" label="姓名">
                    <el-input v-model="ruleForm.name" placeholder="请输入姓名">
                    </el-input>
                </el-form-item>
                <el-form-item prop="phone" label="联系电话">
                    <el-input v-model="ruleForm.phone" placeholder="请输入联系电话">
                    </el-input>
                </el-form-item>
            </el-form>
            <div class="dialog-operate flex align-center justify-center">
                <el-button class="operate black" @click="cancel">取消</el-button>
                <el-button class="operate" :loading="loading" @click="submitForm('ruleForm')">
                    保存
                </el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    import {addKefu} from '@/api/branch'

    export default {
        name: "AddServiceDialog",
        props: {
            applyDialogVisible: {
                type: Boolean,
                default: false
            },
            id: { //详情ID
                type: Number,
            },
            info: {
                type: Object
            }
        },
        data() {
            return {
                loading: false,
                ruleForm: {
                    name: '',
                    phone: '',
                },
                rules: {
                    name: [
                        {required: true, message: '请输入姓名', trigger: 'blur'}
                    ],
                    // phone:rules.tel

                    phone:[
                        {required: true, message: '请输入联系电话', trigger: 'blur'}
                    ],
                },
            }
        },
        created() {
        },
        methods: {
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.addKefu();
                    }
                });
            },
            async addKefu() {
                this.loading = true
                let _data = await addKefu(this.id, this.ruleForm.name, this.ruleForm.phone)
                this.loading = false
                if (_data.status === 200) {
                    this.clearContent()
                    this.$message.success(_data.msg)
                    this.$emit('watchState', true)
                }
            },
            clearContent(){
                this.$refs.ruleForm.resetFields()
            },
            cancel() {
                this.clearContent()
                this.$emit('watchState', false)
            }
        },
        watch: {
            info() {
                if (this.info) {
                    this.ruleForm = {
                        name: this.info.name,
                        phone: this.info.phone,
                    }
                } else {
                    this.ruleForm = {
                        name: '',
                        phone: '',
                    }
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .el-tag + .el-tag {
        margin-left: 10px;
    }

    .button-new-tag {
        margin-left: 10px;
        height: 32px;
        line-height: 30px;
        padding-top: 0;
        padding-bottom: 0;
    }

    .input-new-tag {
        width: 90px;
        margin-left: 10px;
        vertical-align: bottom;
    }

    .detail-dialog-container {
        .dialog-container {
            .dialog-header {
                height: 55px;
                .dialog-title {
                    font-size: 18px;
                    font-weight: bold;
                    color: #0a2240;
                    text-align: center;
                }
                .dialog-close {
                    font-size: 21px;
                    color: #0a2240;
                    font-weight: bold;
                    cursor: pointer;
                }
            }
            .dialog-content {
                padding: 40px 80px;
                height: 605px;
                .title {
                    font-size: 24px;
                    font-weight: bold;
                    color: #0a2240;
                    text-align: center;
                }
                .content {
                    margin-top: 38px;
                    overflow-y: scroll;
                    &::-webkit-scrollbar {
                        display: none
                    }
                }
                .time {
                    font-size: 16px;
                    color: #0a2240;
                    margin-top: 16px;
                }
            }
            .dialog-operate {
                margin-top: 20px;
                .operate {
                    width: 200px;
                    height: 40px;
                    border-radius: 20px;
                    font-size: 16px;
                    background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                    linear-gradient(#ff9600, #ff9600);
                    background-blend-mode: normal, normal;
                    color: #ffffff;
                    &.black {
                        background: #0a2240 none;
                    }
                }
                .operate + .operate {
                    margin-left: 80px;
                }
            }
            .dialog-footer {
                height: 40px;
                background-color: #e7eff9;
                padding: 0 20px;
                border-radius: 0 0 10px 10px;
                .content {
                    font-size: 16px;
                    color: #8b9fbe;
                }
            }
        }
    }
</style>